// node modules
import { computed, Ref, ref } from 'vue'
import { defineStore } from 'pinia'
import { useAuthStore } from './auth'

export interface ConfigStore {
  appTitle: Ref<string>
  env: Ref<string>
  shellUrl: Ref<string>
  chargebeeSite: Ref<string>
  auth0: Auth0Config
  influx: InfluxConfig
}

export interface InfluxConfig {
  influxUrl: Ref<string>
  influxOrg: Ref<string>
  influxBucket: Ref<string>
}

export interface Auth0Config {
  domain: Ref<string>
  clientId: Ref<string>
  audience: Ref<string>
}

export const useConfigStore = defineStore('ConfigStore', () => {
  const authStore = useAuthStore()
  const processEnv = ref(process.env.PROCESS_ENV ?? 'localhost')
  const env = ref(handleEnvironmentVariable(process.env.ENV, processEnv.value))
  const appTitle = ref(handleEnvironmentVariable(process.env.APP_TITLE, processEnv.value))
  const port = ref(handleEnvironmentVariable(process.env.PORT, processEnv.value))
  const shellUrl = computed(() => processEnv.value === 'localhost' ? `http://localhost:${port.value}` : `https://app.${authStore.dc}`)
  const chargebeeSite = ref(handleEnvironmentVariable(process.env.CHARGEBEE_SITE, processEnv.value))

  const auth0Domain = ref(handleEnvironmentVariable(process.env.AUTH0_DOMAIN, processEnv.value))
  const auth0ClientId = ref(handleEnvironmentVariable(process.env.AUTH0_CLIENT_ID, processEnv.value))
  const auth0Audience = ref(handleEnvironmentVariable(process.env.AUTH0_AUDIENCE, processEnv.value))
  const influxUrl = ref(handleEnvironmentVariable(process.env.INFLUX_URL, processEnv.value))
  const influxOrg = ref(handleEnvironmentVariable(process.env.INFLUX_ORG, processEnv.value))
  const influxBucket = ref(handleEnvironmentVariable(process.env.INFLUX_BUCKET, processEnv.value))
  const store: ConfigStore = {
    appTitle,
    env,
    shellUrl,
    chargebeeSite,
    auth0: {
      domain: auth0Domain,
      clientId: auth0ClientId,
      audience: auth0Audience,
    },
    influx: {
      influxUrl,
      influxOrg,
      influxBucket,
    },
  }
  return store
})

function handleEnvironmentVariable(variable: string | undefined, env: string): string {
  if (variable === undefined) {
    if (env !== 'production') {
      throw Error('Received an undefined environment variable')
    }
    return ''
  }
  return variable
}